import { render } from "./DexFileUpload.vue?vue&type=template&id=ed546e38"
import script from "./DexFileUpload.vue?vue&type=script&lang=js"
export * from "./DexFileUpload.vue?vue&type=script&lang=js"

import "./DexFileUpload.vue?vue&type=style&index=0&id=ed546e38&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__